import { machines } from '../machines/machines-sidecar'
import {
  getPathGridSpot,
  IPathGrid,
  IPathNode,
  LevelShip,
  LevelSpace,
  TypeAirlock,
  TypeCorridor,
  TypeLadder,
  TypeSpace,
  TypeSpaceWithShip,
  TypeWall,
} from '../workers/PathFinder2'
import { ITileMapShip } from './tileMapShip'
import { tileMapShip } from './tileMapShip-sidecar'
import { tilesDataShip } from './tilesDataShip-sidecar'

export function createAStarGrid(obj: ITileMapShip): IPathGrid {
  let grid: IPathGrid = {
    width: obj.width,
    height: obj.height,
    nodes: [],
  }

  let std = tilesDataShip.getStandard()

  // Space
  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      let node: IPathNode = {
        i,
        j,
        k: LevelSpace,
        type: TypeSpace,
      }

      let t = tileMapShip.getTileUnsafe(obj, i, j)

      if (t.dataFloor === std.hull) {
        node.type = TypeSpaceWithShip
      }
      if (t.dataFloor === std.floor) {
        node.type = TypeSpaceWithShip
      }
      if (t.dataFloor === std.tube) {
        node.type = TypeSpaceWithShip
      }
      if (t.dataFloor === std.asteroid) {
        node.type = TypeWall
      }

      grid.nodes.push(node)
    }
  }

  // Ship
  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      let node: IPathNode = {
        i,
        j,
        k: LevelShip,
        type: TypeSpace,
      }

      let t = tileMapShip.getTileUnsafe(obj, i, j)

      if (t.dataFloor === std.hull) {
        node.type = TypeWall
      }
      if (t.dataFloor === std.floor) {
        node.type = TypeCorridor
      }
      if (t.dataFloor === std.tube) {
        node.type = TypeLadder
      }
      if (t.dataFloor === std.asteroid) {
        node.type = TypeWall
      }

      grid.nodes.push(node)
    }
  }

  // Allow thorugh on airlock spots
  let mcs = machines.getAll()
  for (let idx = 0; idx < mcs.length; idx++) {
    let mc = mcs[idx]

    if (mc.data.type === 'airlock2') {
      console.log('found airlock!')
      let node = getPathGridSpot(grid, mc.i, mc.j, LevelShip)
      if (node) {
        node.type = TypeAirlock // TODO: for actual spots
      }
    }
  }

  return grid
}
